import { render, staticRenderFns } from "./Cancel.vue?vue&type=template&id=596eb40f&scoped=true&lang=pug"
import script from "./Cancel.vue?vue&type=script&lang=ts"
export * from "./Cancel.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "596eb40f",
  null
  
)

export default component.exports